<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 position-relative">

    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
      {{ 'su-management.users.payment-request-dialog-title' | translate:{ user: userLabel } }}
    </h4>

    <div class="d-flex align-items-center gap-2 w-100 justify-content-center pt-2 payment-request-amount-row">
      <input
        type="number"
        class="form-control payment-request-amount-input"
        min="0"
        step="0.01"
        inputmode="decimal"
        [placeholder]="'su-management.users.payment-request-amount-placeholder' | translate"
        [(ngModel)]="amount"
        name="paymentRequestAmount">
      <span class="zx-text-small flex-shrink-0" [class.text-white]="isDarkMode">{{ 'printing-table.nis' | translate }}</span>
    </div>

    <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 w-100 pt-3">
      <button type="button" (click)="onSend()" [disabled]="!canSend()" mat-raised-button
        class="rounded-pill flex-grow-1 fw-bold text-white payment-request-btn-send">
        <span *ngIf="!isSending">{{ 'su-management.users.payment-request-send' | translate }}</span>
        <mat-spinner *ngIf="isSending" diameter="22" class="mx-auto"></mat-spinner>
      </button>
      <button type="button" (click)="closeDialog()" [disabled]="isSending" mat-button
        class="rounded-pill flex-grow-1 fw-bold payment-request-btn-cancel">
        {{ 'su-management.branches_cancel' | translate }}
      </button>
    </div>

  </div>
</div>
